import { render, staticRenderFns } from "./NewFeatureBadge.vue?vue&type=template&id=2d9505f2&"
import script from "./NewFeatureBadge.vue?vue&type=script&lang=js&"
export * from "./NewFeatureBadge.vue?vue&type=script&lang=js&"
import style0 from "./NewFeatureBadge.vue?vue&type=style&index=0&id=2d9505f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports